module.exports = __webpack_public_path__ + "img/202210251689.a3ba34b6.jpg";